import './Visual.css';
export var visualContainerCSS = '_nlpkgy0-3-15-1';